import { Component, Input, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { LoadingService } from '../../services/loading.service'

@Component({
    selector: 'app-loading',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="loading-overlay" *ngIf="isLoading">
            <div class="loading-spinner">
                <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                </svg>
            </div>
        </div>
    `,
    styles: [`
        .loading-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.8);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 9999;
        }

        .loading-spinner {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #1a73e8;
        }
    `]
})
export class LoadingComponent implements OnInit {
  @Input() isLoading: boolean = false;
  @Input() auto: boolean = false;

  constructor(private loadingService: LoadingService) {}

  ngOnInit() {
    if (this.auto) {
      this.loadingService.loading$.subscribe(isLoading => this.isLoading = isLoading);
    }
  }
}
